import { FinalFormPersistOptions, createPersistDecorator } from "final-form-persist";

export const finalFormPersister = <FormValues = object>(options: FinalFormPersistOptions<FormValues>) => {
  return createPersistDecorator<FormValues>({ debounceTime: 300, storage: sessionStorage, ...options });
};
